/* eslint-disable import/no-unresolved */
import { Grid, Box, Button, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { validationSchema } from '@/utils/helpers';
import Input from '@/components/Forms/Input';
import { selectPrinter } from '@/store/selectors';
import {
  updateDefaultPrinter,
  updateRecieptPrinter,
} from '@/store/slices/printer';
import { closeModal } from '@/store/slices/modal';

const AddPrinterForm = () => {
  const {
    currentName,
    default: defaultPrinter,
    reciept,
  } = useSelector(selectPrinter);
  const dispatch = useDispatch();

  let selectedPrinter;

  if (currentName === 'Default Printer') {
    selectedPrinter = defaultPrinter;
  } else {
    selectedPrinter = reciept;
  }
  const initialState = {
    ipAddress:
      selectedPrinter.ipAddress === 'None' ? '' : selectedPrinter.ipAddress,
    port: selectedPrinter.port === 'None' ? '' : selectedPrinter.port,
  };

  const { dynamic } = validationSchema;

  const handleSubmit = (values: typeof initialState) => {
    const printerObj = {
      name: currentName,
      ipAddress: values.ipAddress,
      port: values.port,
    };

    if (currentName === 'Default Printer') {
      dispatch(updateDefaultPrinter(printerObj));
    } else {
      dispatch(updateRecieptPrinter(printerObj));
    }

    dispatch(closeModal({ type: 'defaultPrinter' }));
  };

  return (
    <Box mt={6}>
      <Formik
        initialValues={initialState}
        enableReinitialize
        onSubmit={handleSubmit}
        validationSchema={yup.object({
          ipAddress: dynamic('IP Address is required'),
          port: dynamic('Port is required'),
        })}
      >
        <Form>
          <Typography textAlign="left" mb={3}>
            This printer will be automatically used when other printers are not
            available
          </Typography>
          <Grid container rowSpacing={4}>
            <Input
              name="ipAddress"
              type="text"
              label="Enter Printer IP"
              size={12}
            />
            <Input
              name="port"
              type="text"
              label="Enter Printer Port"
              size={12}
            />

            <Grid item xs={12} marginTop={10} sx={{ mx: 'auto' }}>
              <Button
                type="submit"
                variant="contained"
                sx={{ borderRadius: 2 }}
              >
                Save Printer
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddPrinterForm;
